import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { BrowserRouter as Router } from "react-router"
import App from "@/App"
import { store } from "@/store"
import "@/index.css"
import "@/style.scss"

if (process.env.BACKGROUND_COLOR) {
   document.documentElement.style.setProperty(
      "--background-color",
      process.env.BACKGROUND_COLOR || "#fafafa"
   )
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
   <Provider store={store}>
      <Router>
         <App />
      </Router>
   </Provider>
)
